import { default as _91_46_46_46slug_93IcbVzV8XRwMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/[...slug].vue?macro=true";
import { default as _404mVDridatnbMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/404.vue?macro=true";
import { default as indexAbRxtWex4YMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedanktgv1gahI7gWMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_93Y3hQGtSx8sMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/contact/[slug].vue?macro=true";
import { default as indexpZXCdTfBYUMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/contact/index.vue?macro=true";
import { default as indexLxZOK6kH2GMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93ev6f7UsMXPMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexbwvbaqnbB0Meta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatiejZZq6LBC7qMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_93Qa3ix75c8DMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93f7MIugiDeSMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indexYcIRyWqBmdMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_935A0EgdGDQwMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_93YBEmowqJreMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_932w8QQcGtadMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_93RrQKGW7Ja6Meta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as indexVgLkzOAitJMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragenxvem80bJzdMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_935cJmPOPuTjMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedankttUAgpIaG1QMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faq9xBm4N33g6Meta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloningCR2A5059qTMeta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijze7dlYoQiO55Meta } from "/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93IcbVzV8XRwMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: indexAbRxtWex4YMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedanktgv1gahI7gWMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_93Y3hQGtSx8sMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexpZXCdTfBYUMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexLxZOK6kH2GMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93ev6f7UsMXPMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexbwvbaqnbB0Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatiejZZq6LBC7qMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_93Qa3ix75c8DMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indexYcIRyWqBmdMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_935A0EgdGDQwMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_93YBEmowqJreMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_932w8QQcGtadMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_93RrQKGW7Ja6Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: indexVgLkzOAitJMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragenxvem80bJzdMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_935cJmPOPuTjMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faq9xBm4N33g6Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/13/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]